import { useState, useEffect } from "react";
import logger from "../../../../util/logger";
import { SHOP_ENABLED } from "../../../../config/appMode";

import Swal from "sweetalert2";

import classnames from "classnames";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
} from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";

import { useTranslation } from "react-i18next";
import Avatar from "../../../../components/Avatar/Avatar";

function ChangeAvatarPage() {
  const { t } = useTranslation("common");

  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [currentAvatar, setCurrentAvatar] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();

      setCurrentAvatar(data.avatar);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };

  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  // eslint-disable-next-line
  const [avatars, setAvatars] = useState([
    // {
    //   id: 1,
    //   image: 'https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png',
    //   beneficiaryUids: [
    //     'h47MFghMFtRbiytKhBF08RCY5z12'
    //   ]
    // },
    // {
    //   id: 2,
    //   image: 'https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png',
    //   beneficiaryUids: [
    //     'h47MFghMFtRbiytKhBF08RCY5z12'
    //   ]
    // },
    // {
    //   id: 3,
    //   image: 'https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png',
    //   beneficiaryUids: [
    //     'h47MFghMFtRbiytKhBF08RCY5z12'
    //   ]
    // },
    // {
    //   id: 4,
    //   image: 'https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png',
    //   beneficiaryUids: [
    //     'h47MFghMFtRbiytKhBF08RCY5z12'
    //   ]
    // },
    // {
    //   id: 5,
    //   image: 'https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png',
    //   beneficiaryUids: [
    //   ]
    // },
    // {
    //   id: 6,
    //   image: 'https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png',
    //   beneficiaryUids: [
    //   ]
    // },
    // {
    //   id: 7,
    //   image: 'https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png',
    //   beneficiaryUids: [
    //   ]
    // },
    // {
    //   id: 8,
    //   image: 'https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png',
    //   beneficiaryUids: [
    //   ]
    // },
    // {
    //   id: 9,
    //   image: 'https://res.cloudinary.com/da3qtg7t5/image/upload/v1683238965/Swift/Default_pfp.svg_ufwfdc.png',
    //   beneficiaryUids: [
    //   ]
    // }
  ]);

  const [avatarCategories, setAvatarCategories] = useState();

  const fetchAvatars = async () => {
    try {
      setIsLoading(true);

      let fetchedAvatars = [];
      let fetchedAvatarCategories = [];

      const q = query(collection(db, "avatars"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newAvatar = doc.data();
        if (!fetchedAvatarCategories.includes(newAvatar.category)) {
          fetchedAvatarCategories.push(newAvatar.category);
        }
        fetchedAvatars.push(newAvatar);
      });

      setAvatars(fetchedAvatars);
      setAvatarCategories(fetchedAvatarCategories);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching avatars");
    }
  };
  useEffect(() => {
    if (user) {
      fetchAvatars();
    }
    // eslint-disable-next-line
  }, [user]);

  const changeAvatar = async (avatarImage) => {
    Swal.fire({
      text: "Are you sure you want to change your avatar?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, I'M SURE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        try {
          const userRef = query(
            collection(db, "users"),
            where("uid", "==", user?.uid)
          );
          const findUsers = await getDocs(userRef);
          findUsers.forEach(async (userObject) => {
            const getUser = doc(db, "users", userObject.id);
            await updateDoc(getUser, {
              avatar: avatarImage,
            });
          });

          fetchAvatars();
          fetchUserData();

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert(err.message);

          setIsLoading(false);
        }
      }
    });
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="changeAvatarPage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        {t("changeAvatar").toUpperCase()}
      </h1>
      {
        // eslint-disable-next-line
        avatarCategories?.map((category) => {
          if (category !== "default") {
            return (
              <div style={{ marginBottom: "1rem" }}>
                <p className="assetCategoryHeader">{category?.toUpperCase()}</p>
                <div id="avatarPageGrid">
                  {
                    // eslint-disable-next-line
                    avatars?.map((avatar) => {
                      logger.debug(avatar.beneficiaryUids);
                      if (
                        (avatar.category === category) &
                        (avatar.image !==
                          "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Favatars%2FdefaultAvatar.png?alt=media&token=4fe7a7cf-b2a3-42bf-9d0a-067cb0fcfd72")
                      ) {
                        return (
                          <div
                            onClick={() =>
                              avatar.image !== currentAvatar &&
                              (!avatar.isPremium ||
                                (avatar.isPremium &&
                                  avatar.beneficiaryUids?.includes(user.uid)))
                                ? changeAvatar(avatar.image)
                                : avatar.isFounders || !SHOP_ENABLED
                                ? null
                                : navigate("/shop")
                            }
                            className={classnames(
                              "avatarPageAvatar",
                              {
                                locked:
                                  avatar.isPremium === true &&
                                  !avatar.beneficiaryUids?.includes(user.uid),
                              },
                              {
                                active: avatar.image === currentAvatar,
                              }
                            )}
                          >
                            <Avatar
                              src={avatar.image}
                              size={64}
                              user={{ avatar: avatar.image }}
                              alt="avatar"
                            />
                          </div>
                        );
                      }
                    })
                  }
                </div>
              </div>
            );
          }
        })
      }
    </div>
  );
}

export default ChangeAvatarPage;
